/**
 * Mixin methods that handle realtime chat actions
 */
// import { mapGetters } from 'vuex'
import axios from 'axios'
// import events from 'Store/events'

export default {
  name: 'mixin-chat-rest-api',
  data () {
    return {
      api: null,
      version: 'v1'
    }
  },
  computed: {
    chatUrl () {
      return new URL(this.currentUser?.homeUrl)
    },

    apiUrl () {
      return `${this.chatUrl?.protocol}//${this.chatUrl?.host}`
    },

    authToken () {
      return this.currentUser?.authToken
    }
  },
  methods: {
    chatRestRequest (method, endpoint, conf, data) {
      return new Promise((resolve, reject) => {
        const config = Object.assign({
          url: `${this.apiUrl}/api/${this.version}/${endpoint}`,
          method: method,
          data: data,
          headers: {}
        }, conf)
        config.headers['X-Auth-Token'] = this.authToken
        config.headers['X-User-Id'] = this.currentUser?.chatUserId
        axios(config).then(resolve).catch(reject)
      })
    },

    setRoomAsRead (roomId) {
      const params = {
        rid: roomId
      }
      const conf = { headers: { 'Content-Type': 'application/json' } }
      this.chatRestRequest('POST', 'subscriptions.read', conf, params)
    },

    uploadMessageFiles (newMessage, replyMessage) {
      const conf = { headers: {} }
      const formData = new FormData()
      formData.append('file', newMessage.files[0].blob, newMessage.files[0].name)
      formData.append('msg', newMessage.content)
      if (replyMessage) {
        formData.append('tmid', replyMessage._id)
      }
      this.chatRestRequest('POST', `rooms.upload/${newMessage.roomId}`, conf, formData)
    },

    // /api/v1/im.create
    createDMRoom (username) {
      const params = {
        username: username
      }
      const conf = { headers: { 'Content-Type': 'application/json' } }
      return this.chatRestRequest('POST', 'im.create', conf, params)
    }
  }
}
